import axiosInstance from './axiosInstance';

const api = axiosInstance;

// 获取所有解决方案
// 更新getAllSolutions函数，使其支持分页参数和语言参数
export const getAllSolutions = (page = 1, pageSize = 6, lang = 'zh') => {
  return axiosInstance.get('/solutions', {
    params: {
      page: page,
      pageSize: pageSize,
      lang: lang
    }
  });
};

// 获取单个解决方案
export const getSolution = (id, lang = 'zh') => axiosInstance.get(`/solutions/${id}`, {
  params: { lang: lang }
});

// 添加解决方案 - 接受配置参数
export const addSolution = (solutionData, config) => axiosInstance.post('/solutions', solutionData, config);

// 更新解决方案 - 接受配置参数
export const updateSolution = (id, solutionData, config) => axiosInstance.put(`/solutions/${id}`, solutionData, config);

// 删除解决方案
export const deleteSolution = (id) => axiosInstance.delete(`/solutions/${id}`);

// 获取最新解决方案
export const getLatestSolutions = () => axiosInstance.get('/solutions/latest');

// 新增：更新解决方案组件
export const updateSolutionComponents = async (solutionId, componentsData) => {
  const response = await axiosInstance.put(`/solutions/${solutionId}/components`, componentsData);
  return response.data;
};

// 解决方案文档相关API
export const getSolutionDocuments = (solutionId) => {
  return axiosInstance.get(`/solutions/${solutionId}/documents`);
};

export const createSolutionDocument = (solutionId, documentData) => {
  return axiosInstance.post(`/solutions/${solutionId}/documents`, documentData);
};

export const updateSolutionDocument = (solutionId, documentId, documentData) => {
  return axiosInstance.put(`/solutions/${solutionId}/documents/${documentId}`, documentData);
};

export const deleteSolutionDocument = (solutionId, documentId) => {
  return axiosInstance.delete(`/solutions/${solutionId}/documents/${documentId}`);
};

// 上传解决方案文档文件
export const uploadSolutionFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/solutions/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 下载解决方案文档文件
export const downloadSolutionFile = (filename) => {
  return axiosInstance.get(`/solutions/download/${filename}`, {
    responseType: 'blob'
  });
};

// 段落相关API
export const getSolutionParagraphs = (solutionId, activeOnly = false) => {
  const params = activeOnly ? { active_only: 'true' } : {};
  return axiosInstance.get(`/solutions/${solutionId}/paragraphs`, { params });
};

export const createSolutionParagraph = (solutionId, paragraphData, config = {}) => {
  return axiosInstance.post(`/solutions/${solutionId}/paragraphs`, paragraphData, config);
};

export const updateSolutionParagraph = (solutionId, paragraphId, paragraphData, config = {}) => {
  return axiosInstance.put(`/solutions/${solutionId}/paragraphs/${paragraphId}`, paragraphData, config);
};

export const deleteSolutionParagraph = (solutionId, paragraphId) => {
  return axiosInstance.delete(`/solutions/${solutionId}/paragraphs/${paragraphId}`);
};

export const reorderSolutionParagraphs = (solutionId, paragraphIds) => {
  return axiosInstance.put(`/solutions/${solutionId}/paragraphs/reorder`, { paragraph_ids: paragraphIds });
};

export default api;